{
    "RestNoContentError": "Response content was expected but none was given",
    "RestJsonProcessing": "Error processing JSON",
    "UnhandlableError": "There was an unhandlable error from the Akixi service.",
    "UnknownError": "There was an unknown server error",
    "NAME": "LanguageErrors"
}